const variants = {
  solid:
    "border border-transparent bg-white-200 focus-within:ring-1 focus-within:ring-green-400",
  outline:
    "border border-gray-200 focus-within:ring-1 focus-within:ring-green-400",
  ghost: "focus-within:ring-1 focus-within:ring-green-400",
  underline:
    "border-0 border-b border-b-extras-border-dark focus-within:border-b-green-400 !px-0 rounded-none",
};

export default variants;
